import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GUIDES } from "@/data/site";
import QuoteCTA from "@/components/QuoteCTA";
import { Reveal, Kicker, MaskedLine } from "@/components/Reveal";

export default function Guides() {
  return (
    <div data-testid="guides-page">
      <section className="px-5 pb-16 pt-32 md:px-10 md:pt-44">
        <div className="mx-auto max-w-[1500px]">
          <Kicker>Guides & Timber Knowledge</Kicker>
          <h1 className="mt-4 max-w-4xl font-display text-5xl font-light leading-[0.95] tracking-tight md:text-7xl">
            <MaskedLine delay={0.1}>Know your timber,</MaskedLine>
            <MaskedLine delay={0.22} className="italic text-kwila">love it longer.</MaskedLine>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-ink/70">
            Practical guides on Kwila care, tannin bleed, species and buying solid timber doors — written for
            homeowners and trade alike.
          </p>
        </div>
      </section>

      <section className="px-5 pb-24 md:px-10">
        <div className="mx-auto grid max-w-[1500px] gap-8 md:grid-cols-2 lg:grid-cols-3">
          {GUIDES.map((g, i) => (
            <Reveal key={g.slug} delay={(i % 3) * 0.08}>
              <Link to={`/guides/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="group block h-full">
                <div className="aspect-[4/3] overflow-hidden rounded-sm">
                  <img src={g.image} alt={g.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="pt-4">
                  <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-sand">
                    {g.tag} · {g.readTime}
                  </p>
                  <h2 className="mt-1 font-display text-2xl leading-tight tracking-tight md:text-3xl">{g.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-ink/60">{g.excerpt}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-kwila">
                    Read guide <ArrowUpRight size={13} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
